import Icon from '@ant-design/icons';

import If from 'global/ErrorHandlers/If';
import { DropDownSvg, LightningSvg } from 'features/day-trade/components/Icons';
import { PaymentMethod } from 'global/Securities/types/transaction';

import { clevertapDayTradeLeverageSelected } from 'lib/analytics/securities';

import { LeverageWrapper, NoneButton, ActionButton } from './leverage.styled';

interface LeverageButtonProps {
  paymentMethod: PaymentMethod;
  multiplier: number;
  enableDayTrade?: boolean;
  isAmend?: boolean;
  onMethodChange: (method: PaymentMethod) => void;
  onOpenModalLeverage: () => void;
}

export default function LeverageButton({
  paymentMethod,
  multiplier,
  enableDayTrade = false,
  isAmend = false,
  onMethodChange = () => {},
  onOpenModalLeverage,
}: LeverageButtonProps) {
  const isTradingBalance = paymentMethod === PaymentMethod.TradingBalance;
  const isTradingLimit = paymentMethod === PaymentMethod.TradingLimit;
  const isDayTrade = paymentMethod === PaymentMethod.DayTrade;

  const isShowBadge = isTradingBalance || isDayTrade;

  const handleNoneButtonClick = () => {
    if (isAmend) return;

    onMethodChange(PaymentMethod.TradingBalance);
    clevertapDayTradeLeverageSelected('None');
  };

  const handleOpenModalLeverage = () => {
    if (isAmend) return;

    onOpenModalLeverage();
    clevertapDayTradeLeverageSelected('Leverage');
  };

  const getDropdownText = () => {
    if (isTradingLimit || !enableDayTrade) {
      return 'Trading Limit';
    }

    if (isDayTrade || isAmend) {
      return `${multiplier}x Day Trade`;
    }

    return `Up to ${multiplier}x`;
  };

  return (
    <LeverageWrapper>
      <NoneButton
        isActive={isTradingBalance}
        isDisabled={isAmend}
        onClick={handleNoneButtonClick}
      >
        None
      </NoneButton>

      <ActionButton
        isActive={!isTradingBalance || isAmend}
        onClick={handleOpenModalLeverage}
      >
        <If condition={isShowBadge && enableDayTrade}>
          <Icon component={LightningSvg} />
        </If>

        {getDropdownText()}

        <If condition={enableDayTrade && !isAmend}>
          <Icon component={DropDownSvg} />
        </If>
      </ActionButton>
    </LeverageWrapper>
  );
}
